import React from "react";

export const About = () => (
  <div>
    <div id="container">
    <h1>About sheworks</h1>
    <h3>Have you ever read Melinda Gates' book, Moment Of Lift?</h3>
    <p>
      She talks about this topic of unpaid labor where women usually do alot of
      unpaid labor like housework, taking care of their kids, making food etc.
      And because of this they are put in a state where it's much more difficult
      for them to find time and energy to actually put effort into working on
      improving themselves, whether that be getting a job, education or exploring
      their own interest etc. 

    </p>
    <p>      
    Sheworks can help them track their unpaid labor each day. 
    We remind them that they too also have the right to improve themselves and should
    be valued for their work.
    </p>
    </div>
  </div>
);
